//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  formField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.25rem',
  },
  title: {
    fontSize: '14px',
    fontWeight: 600,
  },
  subtitle: {
    fontSize: '14px',
    color: colors.grey600,
  },
}));

type Props = {
  title: string,
  subtitle?: string,
  contentRight?: React$Node,
  children?: React$Node,
};

export default function FormField(props: Props) {
  const {title, contentRight, subtitle, children} = props;

  const classes = useStyles();

  return (
    <div className={classes.formField}>
      <div className={classes.header}>
        <div className={classes.headerTitle}>
          <Typography className={classes.title}>{title}</Typography>
          {subtitle && (
            <Typography className={classes.subtitle}>{subtitle}</Typography>
          )}
        </div>
        {contentRight && (
          <div className={classes.headerRight}>{contentRight}</div>
        )}
      </div>

      <div className={classes.content}>{children}</div>
    </div>
  );
}
